import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { toast } from "react-toastify";

export const handleExport = (type, logsData) => {
  if (!logsData || logsData.length === 0) {
    toast.error("No data available to export.");
    return;
  }
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, "0")}-${String(
    today.getMonth() + 1
  ).padStart(2, "0")}-${today.getFullYear()}`;

  const cleanedData = logsData.map((log, index) => ({
    "Sl. No": index + 1,
    Timestamp: new Intl.DateTimeFormat("en-US", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(new Date(log.createdAt)),

    User: log.user?.name || "--",
    Action: log.action_type || "--",
    "Projects/Pages":
      log.project?.project_name || log.page?.project_name || "--",
    Details: log.details || "--",
    "IP Address": log.ip_address || "--",
  }));

  if (type === "excel") {
    const worksheet = XLSX.utils.json_to_sheet(cleanedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Logs");
    XLSX.writeFile(workbook, `logs-${formattedDate}.xlsx`);
  }

  if (type === "pdf") {
    const doc = new jsPDF();
    const columns = Object.keys(cleanedData[0]);
    const rows = cleanedData.map((item) => columns.map((key) => item[key]));

    autoTable(doc, {
      head: [Object.keys(cleanedData[0])],
      body: cleanedData.map((item) => Object.values(item)),
      styles: { fontSize: 8 },
      headStyles: { fillColor: [240, 240, 240], textColor: 20 },
      startY: 20,
    });

    doc.save(`logs-${formattedDate}.pdf`);
  }
};
